import React, { useState } from 'react';
import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, MenuItem, IconButton, Grid, Menu } from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import { AiOutlinePoweroff } from 'react-icons/ai';

// project imports
import LogoSection from '../LogoSection';
// import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';

// assets
import { IconMenu2 } from '@tabler/icons';
// import { useNavigate } from 'react-router-dom';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  // const Navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const islogged = sessionStorage.getItem('UserToken');
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const isMenuOpen = Boolean(anchorEl);
  const handleMenuClose = () => {
    setAnchorEl(null);
    // handleMobileMenuClose();
  };

  const renderMenu = (
    <Menu
      width="15vh"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>English</MenuItem>
      <MenuItem onClick={handleMenuClose}>Hindi</MenuItem>
      <MenuItem onClick={handleMenuClose}>Tamil</MenuItem>
      <MenuItem onClick={handleMenuClose}>Telugu</MenuItem>
      <MenuItem onClick={handleMenuClose}>Malayalam</MenuItem>
    </Menu>
  );
  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
        {islogged ? (
          <>
            <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden', display:{xl:"none",lg:'none', md:"none",sm:"initial", xs:'initial'} }}>
              <Avatar
                variant="rounded"
                sx={{
                  ...theme.typography.commonAvatar,
                  ...theme.typography.mediumAvatar,
                  transition: 'all .2s ease-in-out',
                  background: theme.palette.secondary.light,
                  color: theme.palette.secondary.dark,
                  '&:hover': {
                    background: '#A556B2',
                    color: theme.palette.secondary.light
                  }
                }}
                onClick={handleLeftDrawerToggle}
                color="inherit"
              >
                <IconMenu2 stroke={1.5} size="1.3rem" />
              </Avatar>
            </ButtonBase>
          </>
        ) : null}
      </Box>
      {/* header search */}

      {islogged ? (
        <>
          {/* <SearchSection /> */}
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ flexGrow: 1 }} />

          {/* notification & profile */}
          <NotificationSection />
        </>
      ) : null}
      {islogged ? (
        <>
          <ProfileSection />
          <>
            <Box
              sx={{
                mr: 3
                // [theme.breakpoints.down('md')]: {
                //   mr: 2
                // }
              }}
              container
              spacing={1}
            >
              {/*  */}
              <Grid item sx={{display:"none"}}>
                <MenuItem
                  onClick={handleProfileMenuOpen}
                  sx={{ '&:hover': { backgroundColor: '#FFFFFF' } }}
                  //  sx={{
                  //   ...theme.typography.commonAvatar,
                  //   ...theme.typography.mediumAvatar,
                  //   transition: 'all .2s ease-in-out',
                  //   background: theme.palette.secondary.light,
                  //   color: "#A556B2",
                  //   '&[aria-controls="menu-list-grow"],&:hover': {
                  //     background: "#A556B2",
                  //     color: theme.palette.secondary.light
                  //   }
                  // }}
                >
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    // color="inherit"
                    sx={{
                      borderRadius: '80px',
                      color: '#A556B2',
                      background: theme.palette.secondary.light,
                      padding: '5px 5px 5px 10px',
                      '&:hover': { background: '#A556B2', color: '#FFFFFF' }
                    }}
                  >
                    <Box fontSize={'15px'}>Language</Box>&nbsp;
                    {/* <Box  variant="h5" sx={{color:"#A556B2", '&:hover': { background: "#A556B2", color:"#FFFFFF" }}}>Language</Box>&nbsp; */}
                    <TranslateIcon />
                    <ArrowDropDownIcon />
                  </IconButton>
                  {/* <p>Profile</p> */}
                </MenuItem>
              </Grid>
            </Box>
            <>{renderMenu}</>
          </>
        </>
      ) : null




      }
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
